<template>
    <div class="flex-1">
        <ManageCorrespondenceVue />
    </div>
</template>

<script>
    import ManageCorrespondenceVue from '@/components/ManageCorrespondence.vue';
	export default {
		name: 'ManageCorrespondence',
        components: {ManageCorrespondenceVue},
        data () {
            return {}
        },
	}
</script>